// extracted by mini-css-extract-plugin
export default {"popupWrapper":"styles_popupWrapper__e6o4r","ctrlBtns":"styles_ctrlBtns__pu-Ys"};